<script lang="ts">
    // Seletor de cor livre (o <input type="color"> nativo), diferente do zinput-palette, que oferece
    // um conjunto fechado de cores. Aqui a cor é escolhida no seletor do sistema operacional, e o
    // valor trafega como hexadecimal — é o que as telas de tema esperam gravar.
    import { createEventDispatcher } from 'svelte'

    export let value: string = '#000000'
    export let disabled = false
    export let required = false
    export let labeled = false
    export let htmlInput = null

    const dispatch = createEventDispatcher()

    function onChange(ev) {
        dispatch('change', ev)
    }
    function onFocus(ev) {
        dispatch('focus', ev)
    }
    function onBlur(ev) {
        dispatch('blur', ev)
    }
</script>

<div class="zinput-color zinput_input zinput_input_labeled-{labeled}">
    <input
        {required}
        bind:this={htmlInput}
        type="color"
        bind:value
        {disabled}
        on:change={onChange}
        on:focus={onFocus}
        on:blur={onBlur}
    />
    <span class="zinput-color_hex">{value || ''}</span>
</div>

<style>
    .zinput-color {
        display: flex;
        align-items: center;
        gap: 8px;
    }

    /* o seletor nativo vem com moldura e respiro próprios; o quadrado de cor aqui é só a amostra,
       e o campo em volta já é o do zinput */
    .zinput-color input {
        flex: 0 0 32px;
        width: 32px;
        height: 22px;
        padding: 0px;
        border: 1px solid #99999950;
        border-radius: 3px;
        background: transparent;
        cursor: pointer;
    }

    .zinput-color input:disabled {
        cursor: not-allowed;
    }

    .zinput-color input::-webkit-color-swatch-wrapper {
        padding: 2px;
    }

    .zinput-color input::-webkit-color-swatch {
        border: 0px;
        border-radius: 2px;
    }

    .zinput-color_hex {
        font-size: 13px;
        opacity: 0.6;
        text-transform: uppercase;
    }
</style>
